import React from 'react';

const Calendar: React.FC = () => {
  return (
    <div className="min-h-screen bg-background p-4 flex flex-col" style={{backgroundColor: '#0f172a'}}>
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Calendar</h1>
        <p className="text-muted-foreground">Plan your days</p>
      </header>
      
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-medium text-foreground mb-4">Calendar View</h2>
          <p className="text-muted-foreground">Your upcoming events will appear here</p>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
